export class GsbCategoryGroup {
     _entDefName?: string;
     multiSelect?: boolean;
     orderNumber?: number;
     createdBy_id?: string;
     lastUpdateDate?: Date;
     id?: string;
     lastUpdatedBy_id?: string;
     categories?: GsbCategory[];
     name?: string;
     createDate?: Date;
     title?: string;

     constructor(obj?: Partial<GsbCategoryGroup>) {
         Object.assign(this, obj);
         this._entDefName = "GsbCategoryGroup";
     }
}

export class GsbCategory {
     _entDefName?: string;
     title?: string;
     createDate?: Date;
     code?: string;
     createdBy_id?: string;
     lastUpdatedBy_id?: string;
     group?: GsbCategoryGroup;
     id?: string;
     value?: string;
     lastUpdateDate?: Date;
     group_id?: string;

     constructor(obj?: Partial<GsbCategory>) {
         Object.assign(this, obj);
         this._entDefName = "GsbCategory";
     }
}